<div class="CellRendererSubscribed__indicator" [ngClass]="{ 'CellRendererSubscribed__indicator--subscribed': subscribed }"></div>

{{ subscribed ? 'Subscribed' : 'Not subscribed' }}
